export const generateAlphabetList = (section) => {
	let alphabet = "A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z,123".split(",");
	return alphabet.map((letter) => ({
		key: letter,
		value: letter,
		section,
	}));
};
